<div class="header-bar">
  <h1>Invoices</h1>
</div>
<div class="content-container">
  <div class="" style="position: relative">
    <customers-invoices-grid [manageMode]="1"></customers-invoices-grid>
  </div>
</div>
